import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Button, Skeleton, Modal, Space } from "antd";

function ContractTemplateEditor({
  contract,
  helpVars,
  onEditContract,
  onCloseDrawer,
}) {
  const editorRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const change = () => {
    if (editorRef.current) {
      onEditContract(editorRef.current.getContent());
      onCloseDrawer();
    }
  };


  return (
    <>
      <Editor
        apiKey="u2qr5akn69v8nwpmt0bjjhl39wsuopk7rnklm6j9wkgrxkmu"
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={contract}
        init={{
          height: 350,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "directionality",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks " +
            "bold italic forecolor | link | alignleft aligncenter " +
            " alignright alignjustify | ltr rtl | bullist numlist | table" +
            " help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
      <Space align="baseline">
        <Button onClick={change} style={{ marginTop: 30 }} type="primary">
          ویرایش تعهدنامه
        </Button>
        {helpVars && (
          <Button type="secondary" onClick={() => setModalOpen(true)}>
            راهنما
          </Button>
        )}
      </Space>
      {helpVars && (
        <Modal
          title="متغیرهای تعهدنامه"
          open={isModalOpen}
          footer={
            <Button type="primary" onClick={() => setModalOpen(false)}>
              بستن
            </Button>
          }
        >
          {helpVars && helpVars?.map((hvar) => {
            return (
              <p key={hvar.name}>
                {hvar?.name}: {hvar?.title}
              </p>
            );
          })}
        </Modal>
      )}
    </>
  );
}

export default ContractTemplateEditor;
